import apiClient from './apiClient';

const API_URL = '/tramites/puam';

// Listar / filtrar trámites de PUAM
export const getTramitesPuam = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye checklist)
export const getTramitePuamById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de PUAM
export const crearTramitePuam = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de PUAM:', error.response?.data || error.message);
        throw error;
    }
};

// Preview del checklist. PUAM no tiene condicionales: siempre son los mismos 5 formularios.
export const getChecklistFormularios = async () => {
    const response = await apiClient.get(`${API_URL}/formularios`);
    return response.data;
};

// Editar datos del trámite (no el cliente)
export const actualizarTramitePuam = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosPuam = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistItem = async (idItem, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

const puamService = {
    getTramitesPuam,
    getTramitePuamById,
    crearTramitePuam,
    getChecklistFormularios,
    actualizarChecklistItem,
    actualizarTramitePuam,
    actualizarComentariosPuam,
};

export default puamService;
